import React, { Component } from "react";
import MediaQuery from "react-responsive";
import { withRouter } from "react-router";
import { checkAdminPermission } from "../../../util/utils";
import ManageEventTypeListDesktop from "./ManageEventTypeListDesktop/EventListType";
import ManageEventTypeListMobile from "./ManageEventTypeListMobile/Index";
class ManageEventTypeResponsive extends Component {
  componentDidMount() {
    if (!checkAdminPermission()) {
      this.props.history.push("/");
    }
  }
  render() {
    return (
      <React.Fragment>
        <MediaQuery query="(min-device-width: 1224px)">
          <ManageEventTypeListDesktop />
        </MediaQuery>
        <MediaQuery query="(max-device-width: 1224px)">
          <ManageEventTypeListMobile />
        </MediaQuery>
      </React.Fragment>
    );
  }
}
export default withRouter(ManageEventTypeResponsive);
